import axios from "axios";

export const getReports = async (id, jwt) => {
    // console.log('id', id)
    // console.log('jwt5555', jwt)
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/reports/student/${id}/history`, {
            headers: {
                Authorization: `Bearer ${jwt}`,
            },
        });
        console.log('response', response.data);
        return response.data;
    } catch (error) {
        console.error('Get reports error:', error.response?.data || error.message);
        throw error;
    }
};


export const getSingleReport = async (id, jwt) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/reports/${id}`, {
            headers: {
                Authorization: `Bearer ${jwt}`,
            },
        });
        console.log('response', response.data);
        return response.data;
    } catch (error) {
        console.error('Get reports error:', error.response?.data || error.message);
        throw error;
    }
};